<template>
  <div v-html="itemName"></div>
</template>

<script>
export default {
  computed: {
    row() {
      let row = this.config?.row
      if (_.isObjectLike(row)) {
        return row
      }
      return {}
    },
    itemName() {
      return this.row[this.config?.key]?.text || '-'
    }
  },
  props: {
    config: Object
  },
  methods: {}
}
</script>
